//CONSTANT
import { GET_APP_NAME_FOR_COLLECTION } from "../../app_constant";
//PACKAGES
import { auth, firestore } from "./config";
import { getEffectiveUid } from "./ghostUid";
import _ from "lodash";
import moment from "moment";


const collection = async () => {
  const APP_NAME = await GET_APP_NAME_FOR_COLLECTION();
  return firestore()
    .collection("apps")
    .doc(APP_NAME)
    .collection("users")
    .doc(getEffectiveUid());
};

async function SAVE_TEST_HISTORY(data) {
  try {
    const collection_user = await collection();
    const testToAdd = Array.isArray(data) ? data[0] : data;
    await collection_user.update({
      practice_test_history: firestore.FieldValue.arrayUnion(testToAdd),
    });
    return { status: true, error: "" };
  } catch (error) {
    console.error('Failed to save test history:', error.message);
    return { status: false, error: error.message };
  }
}

async function DELETE_TEST_HISTORY(data) {
  try {
    const collection_user = await collection();
    await collection_user.update({
      practice_test_history: firestore.FieldValue.arrayRemove(data),
    });
    return { status: true, error: "" };
  } catch (error) {
    return { status: false, error: error.message };
  }
}

async function SAVE_DIAGNOSTIC_RESULTS(profile, addAllQuestionScore, setTestHistory) {
  try {
    const diagnosticData = localStorage.getItem('onboarding_test_result');
    const selectedExamData = localStorage.getItem('onboarding_test_selected_exam');

    if (!diagnosticData || !selectedExamData) {
      return { status: true, message: "No diagnostic data to save" };
    }

    let testData, selectedExam;
    try {
      testData = JSON.parse(diagnosticData).testData;
      selectedExam = JSON.parse(selectedExamData);
    } catch (parseError) {
      console.error('Failed to parse diagnostic data from localStorage:', parseError.message);
      localStorage.removeItem('onboarding_test_result');
      localStorage.removeItem('onboarding_test_selected_exam');
      return { status: false, error: "Corrupted diagnostic data" };
    }

    if (!testData) {
      return { status: true, message: "No test data to save" };
    }

    const testHistoryData = {
      test_name: testData.test_name,
      total: testData.total,
      correct: testData.correct,
      incorrect: testData.incorrect,
      unanswered: testData.unanswered,
      score: testData.score,
      total_time: testData.total_time,
      time_taken: testData.time_taken,
      remaining_time: testData.remaining_time,
      date: moment().format("MMM DD, YYYY HH:mm:ss"),
      is_new_app_test: true,
      // Flag the onboarding diagnostic so the shared guidance engine's
      // diagnostic-gated rules (isDiagnosticContinuationActive / hasNonDiagnosticTest)
      // work on web too — mobile sets this on its replayed entry.
      is_diagnostic: true,
      test_questions_meta_data: testData.test_questions_meta_data.map(q => ({
        question_id: q.question_id,
        topic_id: q.topic_id,
        response: q.response,
        selected_choice: q.selected_choice || q.response
      }))
    };

    // Save test history
    setTestHistory(testHistoryData);

    // Save individual question scores
    const questionList = testData.test_questions_meta_data.map(element => ({
      question_id: element.question_id,
      topic_id: element.topic_id,
      correct: element.response === 'CORRECT',
      selected: element.response,
    }));

    // Await the per-question score writes so they are committed to Firestore
    // BEFORE the caller (prepare.js) hard-reloads to Home. The reloaded app
    // re-sources scores only from Firestore, and the Home "review incorrect"
    // nudge must not compute a pool the reloaded state can't reproduce.
    await addAllQuestionScore(questionList);

    // Clear localStorage only after both saves are initiated
    localStorage.removeItem('onboarding_test_result');
    localStorage.removeItem('onboarding_test_selected_exam');

    return { status: true, message: "Diagnostic results saved successfully" };
  } catch (error) {
    console.error('Failed to save diagnostic test results:', error.message);
    return { status: false, error: error.message };
  }
}

export { SAVE_TEST_HISTORY, DELETE_TEST_HISTORY, SAVE_DIAGNOSTIC_RESULTS };
